export default {
  namespaced: true,
  procedure_states: {
    scheduled: "Scheduled",
    in_progress: "In Progress",
    in_review: "In Review",
    reopened: "Reasigned",
    rejected: "Rejected",
    approved: "Approved",
    cancelled: "Cancelled",
    canceled: "Canceled",
    completed: "Completed",
    review: "In Review",
    value: {
      scheduled: "Scheduled",
      in_progress: "In Progress",
      in_review: "In Review",
      rejected: "Rejected",
      approved: "Approved",
      cancelled: "Cancelled",
      canceled: "Canceled",
      reassigned: "Reassigned",
      completed: "Completed",
      review: "In Review",
    },
  }
}
